import { useState } from "react";
import { ApiError, api } from "../lib/api";

export function Login({ onLogin }: { onLogin: () => void }) {
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="login-screen">
      <form
        className="login-card"
        onSubmit={async (e) => {
          e.preventDefault();
          setBusy(true);
          setError(null);
          try {
            await api.login(pw);
            onLogin();
          } catch (err) {
            setError(err instanceof ApiError && err.status === 401 ? "Wrong password" : "Login failed");
          } finally {
            setBusy(false);
          }
        }}
      >
        <h1>
          <span aria-hidden>🍴</span> Forklore
        </h1>
        <input
          autoFocus
          type="password"
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          placeholder="Password"
          disabled={busy}
        />
        <button type="submit" disabled={busy || !pw}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
        {error && <div className="error">{error}</div>}
      </form>
    </div>
  );
}
